import { Badge, Card, CardContent, CardHeader, CardTitle } from "@/ui";
const aboutUsImage = "/assets/website/images/Professional_healthcare_team_company_3c5b6572.png";
const evertonPhoto = "/assets/website/teams/Everton.jpg";
const senthilPhoto = "/assets/website/teams/senthil_ramachandran_profile_photo.png";

export default function AboutUs() {
  return (
    <div
      className="min-h-screen font-sans"
      style={{
        backgroundImage: "url('/assets/shared/simple-bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        fontFamily: "Montserrat, system-ui, sans-serif",
      }}
    >
      <main className="py-20">
        {/* Hero Image Section */}
        <div className="relative h-80 mb-20 overflow-hidden">
          <img 
            src={aboutUsImage} 
            alt="Professional Healthcare Team Company"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-background/60" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <Badge variant="secondary" className="mb-4" data-testid="badge-about">
                About Us
              </Badge>
              <h1 className="text-3xl md:text-4xl font-normal text-primary mb-4" data-testid="text-about-title" style={{ fontFamily: "Montserrat, system-ui, sans-serif" }}>
                Transforming Healthcare Through AI Innovation
              </h1>
              <p className="text-xl text-foreground max-w-3xl mx-auto" data-testid="text-about-description" style={{ fontFamily: "Montserrat, system-ui, sans-serif" }}>
                AIscendus is dedicated to revolutionizing healthcare delivery through intelligent AI agents 
                that streamline workflows and enhance patient outcomes.
              </p>
            </div>
          </div>
        </div>
        
        <div className="container mx-auto px-4">

          <div className="mb-16">
            <h2 className="text-3xl font-normal text-center mb-12" data-testid="text-team-title" style={{ fontFamily: "Montserrat, system-ui, sans-serif" }}>
              Our Team
            </h2>
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto px-4">
              <Card className="text-center w-full" data-testid="card-ceo-cto">
                <CardHeader>
                  <div className="relative w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden border-4 border-primary/20">
                    <img 
                      src={senthilPhoto} 
                      alt="Senthil Ramachandran"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <CardTitle className="text-xl">Senthil Ramachandran</CardTitle>
                  <p className="text-primary font-semibold mt-2">CEO / CTO</p>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Innovative technology executive with a proven record of leading AI-driven transformations across Healthcare, Financial Services, Insurance, Telecom, and Pharma.
                    <br /><br />
                    An expert in Generative and Agentic AI, Cloud Strategy, and AI/ML Operations, he builds autonomous and interoperable ecosystems that enable intelligent workflows, predictive insights, and enterprise-wide efficiency.
                    <br /><br />
                    He is driving AI innovation across industries—advancing patient-centric care delivery in healthcare and enhancing decision intelligence in finance and insurance through automation, analytics, and interoperability.
                    <br /><br />
                    A recognized leader in responsible, explainable, and scalable AI, Senthil champions human-centered innovation that unites intelligence, automation, and trust.
                  </p>
                </CardContent>
              </Card>

              <Card className="text-center w-full" data-testid="card-cio">
                <CardHeader>
                  <div className="relative w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden border-4 border-primary/20">
                    <img 
                      src={evertonPhoto} 
                      alt="E. Llewellyn Weeks"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <CardTitle className="text-xl">E. Llewellyn Weeks</CardTitle>
                  <p className="text-primary font-semibold mt-2">CIO</p>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    E. Llewellyn Weeks brings over 30 years of leadership across healthcare and financial services, combining strategic vision with deep technical acumen. He has led major digital transformations at Bank of America, Fleet Bank, and Citizens Bank, modernizing enterprise systems and strengthening data, security, and compliance frameworks.
                    <br /><br />
                    In healthcare, Llewellyn has delivered innovative solutions that improve clinical efficiency, patient engagement, and interoperability, aligning technology with real-world care outcomes.
                    <br /><br />
                    At Aiscendus, Llewellyn is driving the Agentic Healthcare transformation—leading the development of AI-powered, interoperable platforms that enhance decision intelligence and operational excellence across care delivery. His leadership ensures Aiscendus continues to shape the future of autonomous, intelligent healthcare systems built on innovation, trust, and purpose.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}